import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { AlertService } from 'src/app/services/alert.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-alarm-list',
    templateUrl: './alarm-list.component.html',
    styleUrls: ['./alarm-list.component.css']
})
export class AlarmListComponent implements OnInit {
    @Input() systemId: string | null = null;

    alerts$: any;
    isHandset$: Observable<boolean>;
    isMobile: boolean = false;

    constructor(
        private alertService: AlertService,
        private breakpointObserver: BreakpointObserver
    ) {
        this.isHandset$ = this.breakpointObserver.observe(['(max-width: 960px)'])
            .pipe(map(result => result.matches));
    }

    ngOnInit() {
        this.isHandset$.subscribe(isMobile => this.isMobile = isMobile);
        console.log('AlarmListComponent initialized with systemId:', this.systemId);

        

        if (this.systemId) {
            this.alerts$ = this.alertService.getAlertsBySystemId(this.systemId)
        } else {
            this.alerts$ = this.alertService.getAllAlerts(1000);
        }

        this.alerts$.pipe(
                map((alerts : any) => {
                    // Sort alerts by startsAt descending, and if same, resolved over firing
                    const mapped = alerts
                        .map(alert => ({
                            ...alert,
                            startsAtDate: alert.startsAt ? toDate(alert.startsAt) : null
                        }));

                    return mapped.sort((a, b) => {
                        if (!a.startsAtDate || !b.startsAtDate) return 0;
                        const diff = b.startsAtDate.getTime() - a.startsAtDate.getTime();
                        if (diff !== 0) return diff;
                        // If same startsAt, resolved first (case-insensitive)
                        const aResolved = typeof a.status === 'string' && a.status.toLowerCase() === 'resolved';
                        const bResolved = typeof b.status === 'string' && b.status.toLowerCase() === 'resolved';
                        if (aResolved !== bResolved) {
                            return aResolved ? -1 : 1;
                        }
                        return 0;
                    });
                })
            );

        this.alerts$.subscribe(alerts => {
            console.log('Alerts for system:', this.systemId, alerts);
        });
    }

    deleteAlert(alert: any) {

        const alertId = alert.id;

        if (confirm('Are you sure you want to delete this alert?')) {
            this.alertService.deleteAlert(alertId).then(() => {
                console.log('Alert deleted:', alertId);
            }).catch(error => {
                console.error('Error deleting alert:', error);
            });
        }
    }

}

function toDate(startsAt: any): Date | null {
    if (!startsAt) return null;
    if (startsAt instanceof Date) return startsAt;
    if (typeof startsAt === 'object' && typeof startsAt.seconds === 'number') {
        return new Date(startsAt.seconds * 1000 + Math.floor((startsAt.nanoseconds || 0) / 1e6));
    }
    return null;
}
